import {CommandDto, CommandDtoCommandTypeEnum, ConditionDto, TestPlanExecutionDtoRunStatusEnum, TimeOffset} from "../api";
import {Tag, Tooltip} from "antd";
import React from "react";
import {InfoCircleOutlined} from "@ant-design/icons";

export function getPathvariables(url: string | undefined): string [] {
    if (url === undefined) return [];

    const pathVariablePattern = /\{([^}]+)\}/g;
    const matches = url.match(pathVariablePattern);

    if (matches) {
        return matches.map(match => match.slice(1, -1));
    } else {
        return [];
    }
}

export function formatDateTime(dateTimeString: string | undefined): string {
    if (!dateTimeString) return ''; // Wenn dateTimeString undefiniert ist, gib einen leeren String zurück

    const parsedDate = new Date(dateTimeString);
    return parsedDate.toLocaleString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}

export function getTimeOffsetString(timeOffset: TimeOffset): string {
    return timeOffset.days + " Tage : " + timeOffset.hours + " Stunden : " + timeOffset.minutes + " Minuten : " + timeOffset.seconds + " Sekunden"
}


export function renderStatusAmpel(status: TestPlanExecutionDtoRunStatusEnum) {
    switch (status) {
        case TestPlanExecutionDtoRunStatusEnum.Success:
            return <Tag color="green">Erfolgreich</Tag>;
        case TestPlanExecutionDtoRunStatusEnum.Failed:
            return <Tag color="red">Fehlgeschlagen</Tag>;
        case TestPlanExecutionDtoRunStatusEnum.Unknown:
            return <Tag color="yellow">Unbekannt</Tag>;
        case TestPlanExecutionDtoRunStatusEnum.Paused:
            return <Tag color="yellow">Pausiert</Tag>;
        case TestPlanExecutionDtoRunStatusEnum.Executing:
            return <Tag color="yellow">Ausführung</Tag>;
        default:
            return <Tag color="gray">N/A</Tag>;
    }
}

export function setOrderIndexOfCommandDtos(commandDtos: CommandDto[]): CommandDto[] {
    for (let i = 0; i < commandDtos.length; i++) {
        commandDtos[i].orderIndex = i;
    }
    return commandDtos;
}

export function getErrorMessage(error) {
    let message = "";
    if (error.response) {
        switch (error.response.status) {
            case 401:
                message = "Fehler bei der Authorisierung aufgetreten";
                break;
            case 403:
                message = "Zugriff verweigert";
                break;
            case 404:
                message = "404";
                break;
            case 500:
                message = "Ein interner Fehler ist aufgetreten";
        }
    }
    return message;
}

export const getLabelWithNameAndInfotext = (name, ...infoText) => {
    return (
        <span>
      {name}&nbsp;
            <Tooltip overlayStyle={{maxWidth: '600px'}}
                     title={<span>{infoText.map((text, index) => <div key={index}>{text}</div>)}</span>}>
        <InfoCircleOutlined/>
      </Tooltip>
    </span>
    );
};

export function translateCommandType(commandType: CommandDtoCommandTypeEnum): string {
    const translations: Record<CommandDtoCommandTypeEnum, string> = {
        CHECK_STATUS: 'Zustand prüfen',
        EXECUTE: 'Ausführen',
        NAVIGATE: 'Navigieren',
        SAVE_VALUE: 'Variable speichern',
        COMPARE_VALUE: 'Vergleichen',
        PREFAB: 'Komponente',
        REQUEST: 'API',
        WAIT: 'Warten',
        DIALOG: 'Dialog',
        PAUSE: 'Pause',
        IMPORT: 'Importieren',
        PAUSE_RECORD: 'Pausieren für Aufzeichnung'
    };

    return translations[commandType] || 'Unbekannter Befehl';
}

export function translateConditionToReadableString(condition: ConditionDto | undefined): string {
    if(condition){
        switch (condition.type){
            case "VAR_EXISTS":
                return "Variable existiert: " + condition.variableName;
            case "VAR_NOT_EXISTS":
                return "Variable existiert nicht: " + condition.variableName;
            case "VAR_EQUALS":
                return condition.variableName + " = " + condition.checkValue;
            case "VAR_NOT_EQUALS":
                return condition.variableName + " != " + condition.checkValue;
        }
    }
    return "";
}


